import ApiClient from '@/api/ApiClient';
import BaseService from './BaseService';
import Material from '@/api/models/Material';
import MaterialDictionary from '@/dictionary/MaterialDictionary';

class MaterialService extends BaseService {
    #prefixUrl = 'api/material/';

    STORAGE_DEFINITION = {
        MATERIAL_LIST: 'materialList',
    };

    constructor() {
        super();
        this.api = new ApiClient(this.#prefixUrl);
    }

    /**
     * Get all Material
     * @returns {Array}
     */
    async get() {
        let meterial = [];

        const response = await this.api.executeRequest(`/`, {}, this.api.methods.GET);

        if (response.success() && response.getContent() != null) {
            for (let materialData of response.getContent()) {
                meterial.push(new Material(materialData));
            }
        }

        return meterial;
    }

    /**
     * Get all Material
     * @returns {Array}
     */
    async getGroups() {
        let materialGroups = this.getArrayOnStorage(this.STORAGE_DEFINITION.MATERIAL_LIST);
        
        if (materialGroups.length == 0) {
            const response = await this.api.executeRequest(`/groups`, {}, this.api.methods.GET);

            const materialDictionary = new MaterialDictionary();

            if (response.success() && response.getContent() != null) {
                for (let statusId of response.getContent()) {
                    materialGroups.push(materialDictionary.getItem(statusId));
                }
            }

            this.saveArrayOnStorage(this.STORAGE_DEFINITION.MATERIAL_LIST, materialGroups);
        }

        return materialGroups;
    }

    /**
     * Gets Student allowed materials
     * @param {Integer} studentId
     * @returns {Array}
     */
    async getStudentMaterials(studentId = null) {
        let meterial = [];

        const response = await this.api.executeRequest(`/student_materials/${studentId}`, {}, this.api.methods.GET);

        if (response.success() && response.getContent() != null) {
            for (let materialData of response.getContent()) {
                meterial.push(new Material(materialData));
            }
        }

        return meterial;
    }

    /**
     * Saves Material by creating or updating
     * @param {Object} materialData
     * @returns {api/models/Response}
     */
    async save(materialData = {}) {
        const response = await this.api.executeRequest('/', materialData, this.api.methods.POST, {
            headers: {
                "Content-Type": "multipart/form-data",
            }
        });

        if (response.success() && response.getContent() != null) {
            const materialObject = new Material(response.getContent());
            response.setContent(materialObject);
        }
        
        return response;
    }

    /**
     * Tries to get resourse blob data
     * @param {integer} materialId 
     * @returns {blob|null}
     */
    async fetchDonwloadData(materialId = null) {
        return await this.api.executeRequest(`download/${materialId}`, {}, this.api.methods.GET, {responseType: 'blob'});
    }

    /**
     * Delets Material
     * @param {integer} studentId
     * @returns {Response} 
     */
    async delete(materialId = null) {
        return await this.api.executeRequest(`/${materialId}`, {}, this.api.methods.DELETE);
    }
}

export default new MaterialService();
